import React from 'react';
import { Layout, RoutesMenu, GetInfo } from '../../components';
import '../../assets/styles/containers/Routes.sass';

const Stage2 = () => {
  return (
    <div className="Stage2">
      <Layout bannerId={73}>
        <RoutesMenu/>
        <div className="container">
          <GetInfo id={140}/>
        </div>
      </Layout>
    </div>
  );
};

export default Stage2;
